var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-tip v-popper--usearrow",class:_vm.extClass,style:(`z-index:${_vm.zIndex};${_vm.postionStyle}`),attrs:{"x-placement":_vm.placement}},[_c('span',{staticClass:"v-popper__arrow",style:(_vm.arrowStyle)}),_c('div',{staticClass:"v-popper__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }